/**
 * @generated SignedSource<<8e5900139ec715c621aadd7e384327d0>>
 * @relayHash e04bcb743a2af95309967488bc0303c0
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e04bcb743a2af95309967488bc0303c0

import type { ConcreteRequest } from 'relay-runtime';
export type useViewerSafeViewerSharedQuery$variables = Record<PropertyKey, never>;
export type useViewerSafeViewerSharedQuery$data = {
  readonly safeViewer: {
    readonly __typename: "User";
    readonly avatarUrl: string;
    readonly id: string;
    readonly login: string;
    readonly name: string | null | undefined;
    readonly profileResourcePath: string | null | undefined;
  } | null | undefined;
};
export type useViewerSafeViewerSharedQuery = {
  response: useViewerSafeViewerSharedQuery$data;
  variables: useViewerSafeViewerSharedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "safeViewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "login",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "profileResourcePath",
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "size",
            "value": 64
          }
        ],
        "kind": "ScalarField",
        "name": "avatarUrl",
        "storageKey": "avatarUrl(size:64)"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useViewerSafeViewerSharedQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useViewerSafeViewerSharedQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "e04bcb743a2af95309967488bc0303c0",
    "metadata": {},
    "name": "useViewerSafeViewerSharedQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ec14349f609753fe2f861f8c75dc87f5";

export default node;
